import { RootState } from '../../../iwProvider/configureStore';
import { connect } from 'react-redux';

import MainContentPending from '../../pageStructure/mainContentPending';
import { useQuery } from '@tanstack/react-query';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import { FlexiApprovedView } from './flexiApprovedView/FlexiApprovedView';
import DefaultView from '../defaultView/DefaultView';
import LoanBuilder from './loanBuilder/LoanBuilder';
import FallbackErrorModal from '../../modals/fallbackErrorModal/FallbackErrorModal';
import { XSell } from './xsell/xsell';
import { getFormalOfferType } from '../getFormalOfferType';
import { useSplitTests } from '@api/lendingAPI/lapiHooks';
import { RBLOfferConfigurationView } from './NewApprovedView/RBLOfferConfigurationView/RBLOfferConfigurationView';

const mapStateToProps = ({ siteContext }: RootState) => ({
    stateKey: siteContext.impersonatingStateKey || siteContext.state_key
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const ApprovedView = ({ stateKey }: PropsFromRedux) => {
    const isInUniApprovedViewSplitTest = useSplitTests(
        'uni_approved_view_test_2023'
    );

    const {
        isLoading,
        isError,
        data: formalOfferType
    } = useQuery({
        queryKey: ['formal_offers', stateKey],
        queryFn: () => fetchGetFormalOffers({ stateKey: stateKey! }),
        select: (data) => getFormalOfferType(data, isInUniApprovedViewSplitTest)
    });
    if (isLoading) {
        return <MainContentPending data-testid="approved-view-loading" />;
    }

    if (isError) {
        return <FallbackErrorModal />;
    }

    switch (formalOfferType) {
        case 'credit_facility':
        case 'flexi24':
            return <FlexiApprovedView />;
        case 'x_sell':
            return <XSell />;
        case 'multi_choice':
            return <LoanBuilder />;
        case 'merchant_cash_advance':
            return <RBLOfferConfigurationView />;
        default:
            return <DefaultView />;
    }
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ApprovedView);
